import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const useCases = [
  {
    id: "U2UCI301",
    title: "De-Risking Field Development via  AI/ML Driven Petrophysical Rock Typing  (PRT)",
    members: "Sabyasachi Bhowmick, Sanjoy Das, Shashi Kumar  Suman, Shubham Gupta, Kitho Stephen, Neerudu  Ragalbande, Malini Chakraborty"
  },
  {
    id: "U2UCI307",
    title: "Drilling with Real-time Intelligence for  Stuck Pipe Risk Mitigation",
    members: "Bala S Nallagondla, Ramu Pedumajji, Rajjan Singh  Thakur, Santosh Kumar Gupta, Murugesan M K,  Harish N, Pankaj Kumar, D. Krishna Reddy, Vinod,  Kanobaji Zile, Shailesh Chandra Sinha"
  },
  {
    id: "U2UCI234",
    title: "aiRR: AI assisted IRR & Risk Framework  for optimal well drilling and cost  efficiency",
    members: "Satish Chandra Gupta, Satish Kumar, Bhargab  Goswami, Hema S Rao Kambala, Raghvendra Sharma"
  },
  {
    id: "U1UCI080",
    title: "Real-time Pore-pressure prediction  using AI models for fast & accurate  decision making",
    members: "Lakshman Katherla, K Praveen Kumar, Jagannath  Chaudhary, V L L Krishnaveni Emani, Santhosh Kumar  Gupta"
  },
  {
    id: "U2UCI447",
    title: "TATHYA.AI : Transforming Documents  into Actionable Subsurface Intelligence",
    members: "Vinay Sahu, Sarabjeet Singh Dhanjal, Mandeep Singh,  Sudhir Sharma"
  },
  {
    id: "U2UCI126",
    title: "A Real-Time Optical Character  Recognition System Utilizing a  VisionLanguage Model of Oil and Gas  Industry",
    members: "Santosh Kumar Sahu, Prashant Kumar Dubey, Nebula  Bagchi, Davinder Singh, Venkatesh P, Suresh Konka,  Satya Narayan, Nikhil Singh, Neha Pandey"
  },
  {
    id: "U2UCI395",
    title: "AI Based PPE Monitoring System",
    members: "Shrishti Awasthi"
  },
  {
    id: "U2UCI038",
    title: "A centralized HSE Ranking System to  assess the Safety performance of SBU  based on selected elements",
    members: "Alka Yadav, Jayashree Prusty, Pawan Kumar  Jalutharia, Arshad Hussain, Paul Mickey Toppo, Prem  Prakash Hansda, Vivek Singh"
  },
  {
    id: "U2UCI362",
    title: "Machine Learning-Based Refinery  Profit Optimization & Quality  Assurance",
    members: "Mudavath Priyatham Naik, V Hrushikesh Reddy, AM  Rahman, Shubhendu Sharan Gupta, Amit Kumar,  Prafful Mittal, Suryamani Kumar, Koushik Mondal,  Santanu Das, Chimaladari Deepank"
  },
  {
    id: "U2UCI376",
    title: "AI Driven Well Monitoring and Flow  Cycle Optimization",
    members: "V Hrushikesh Reddy, Rahman A M, Mudavath  Priyatham Naik, Shubhendu Sharan Gupta, Pankaj  Kumar, Vaibhav Kumar Lakra, Vishal Mittal, Jayant  Kumar, Veluri Ravi Teja"
  },
  {
    id: "U2UCI255",
    title: "ML-Driven H₂S Elimination in Gas  Pipelines and Strategic Reduction of  Non-Eco Friendly Chemical Usage  Across ONGC Installations",
    members: "Sushant Gupta, AM Rahman, V Hrushikesh Reddy,  Mudavath Priyatham Naik, Koushik Mondal, Deepak  Kumar Vishwakarma, Jeetendra Bobanga, B Satya  Srinivasa Kumar"
  },
  {
    id: "U2UCI249",
    title: "ESP-360: Real Time Failure & Residual  Equipment Life Prediction Using  Artificial Intelligence",
    members: "Choppala Satya Tej, Manoj Mishra, Manoj Mehta,  Saksham Gupta, Ashish Saini, Ashutosh Pathak,  Bhavishy Kumar Gupta"
  },
  {
    id: "U2UCI239",
    title: "Optimizing Number of Upholes in  Seismic Data Acquisition Using ML",
    members: "Sh Bronson Aimol, Saswata Bag, Dharmendra Kumar,  Manav Kumar"
  },
  {
    id: "U2UCI364",
    title: "From Digital Archival to AI-Driven  Block Intelligence: Evolution of a  Unified Data Strategy for Strategic  Exploration Decision-Making",
    members: "Rakesh Kr. Yadav, Ramkaran Singh, Rupjyoti Dutta,  Jainendra Srivastava, Bhairav Changkakoty, Umang  Nagpal, Kalaiselvi S., Brijesh Kr. Pandey, Piyush  Nayal, Pawan Singh, Hardeep P., Abhishek Bisui,  Rehan Ansari, Dipankan Srivastava"
  },
  {
    id: "U2UCI232",
    title: "Smart Inventory Management &  Forecasting",
    members: "Ramu Pedumajji, Bala Saidulu Nallagondla, Rajjan  Singh Thakur, Santosh Kumar Gupta, Pankaj Kumar,  Murugesan M K, Harish N, Dharmavarapu Krishna  Reddy, Mathialagan P , Vishal Mittal"
  },
  {
    id: "U2UCI424",
    title: "Predictive Telemetry: Dynacard  Interpretation Using Machine Learning  for SRP Failure Prediction &  Optimization",
    members: "Sagun Devshali, Deepak Gunwant, Rajjan Singh  Thakur, Jitendra Dadhich"
  },
  {
    id: "U2UCI414",
    title: "Unlocking the Deep-water Frontier:  AIDriven Workflow to identify  lithofacies e.g., Volcanics, Carbonates &  Clastics; Sweet Spot Mapping",
    members: "Prosenjit Das, Ayan Kumar Mondal, Umang Nagpal,  Sayandeep Roy, G. Parthiban"
  },
  {
    id: "U2UCI428",
    title: "GGS Management App & Portal",
    members: "Sonu Kumar Singh, Sukumar Laha, Ravi Kumar  Sharma, Alpesh Parmar"
  },
  {
    id: "U2UCI052",
    title: "AI/ML Based Work-over Rig Scheduling  & Candidate Selection",
    members: "Kaushal Agrawala, Sohil Shah, Alok Verma, Harini L"
  },
  {
    id: "U2UCI413",
    title: "Utilization Of Drilling Cuttings for  Internal Road Laying & Civil Works",
    members: "Haritha Maddi, V. Sreedher, Roshan P Koshy, Nainesh  B Shah"
  },
  {
    id: "U2UCI290",
    title: "AI-Based Virtual Inline Inspection (VILI)  for Predictive Integrity Assessment of  Pipelines",
    members: "Neeraj Kumar, Deepak Gunwant, Peter Youngreen  Vaddi"
  },
  {
    id: "U2UCI021",
    title: "TransAI - an AI augmented Regime  Identification Python script for Well  Test Interpretation",
    members: "Sabyasachi Saikia, Abhineet Baruah, Arnav, Anamika  Gahlot, Aamir Iqbal, Adarsh Tripathi"
  },
  {
    id: "U2UCI093",
    title: "AI-Driven Economic Gatekeeping for  Workover Jobs",
    members: "Nirmal Kumar Mishra, Devendra Kumar Agrawal,  Sugata Guchhait, Praveen Kumar Jha, Vishal Kumar,  Prateek Gupta, Brijbhushan Ahuja"
  },
  {
    id: "U2UCI440",
    title: "Automation of Joint Venture Budgeting",
    members: "Bipin M. Patel, Pratima Mantri, Sunil Kumar, Debashis  Saha"
  },
  {
    id: "U2UCI175",
    title: "AI‑Based Bottom Hole Pressure  Forecasting and Anomaly Detection",
    members: "Manish Kumar"
  },
  {
    id: "U2UCI176",
    title: "Virtual Sensor for Estimation of Bottom  Hole Pressure",
    members: "Manish Kumar"
  },
  {
    id: "U2UCI444",
    title: "AI-Enabled Digital Repository for MVT  and Safety Competency Certificates",
    members: "Anshu Kumar, Manish Kumar, Joseph Mattamana,  Nirmal Kumar Mishra"
  },
  {
    id: "U2UCI445",
    title: "Agentic AI Solution for Automating and  Augmenting the Nomination Audit  Reports",
    members: "Anshu Kumar, Sudesh Kakkar, Pawan Kumar, Manish  Kumar, Joseph Mattamana, Sreenath S Das"
  },
  {
    id: "U2UCI166",
    title: "Automation Of Supply Chain of  Chemicals & Integration of Data on a  Surface Chemistry Portal",
    members: "Sanglap Das"
  },
  {
    id: "U2UCI419",
    title: "Maintenance Portal: Unified equipment  health monitoring tool",
    members: "Dinesh Kumar Pappula, C Ramachandran, Ayush Jain,  Varun Prasad"
  },
  {
    id: "U2UCI152",
    title: "AI Agent for Automated Well  Modelling and Simulation Studies",
    members: "Aman Sharma, Devesh Tembhurkar, Pankaj Sharma"
  },
  {
    id: "U2UCI153",
    title: "Time cycle staggering of Intermittent  Gas Lift (IGL) wells using AI",
    members: "Aman Sharma, Devesh Tembhurkar, Pankaj Sharma"
  },
  {
    id: "U1UCI190",
    title: "On-line data-driven decision-making as  per international best practices for ETP  operational integrity and compliance  by replacing “fix-on-failure” with  proactive",
    members: "Amor Nath Mondal, Ashish Sharma"
  },
  {
    id: "U2UCI346",
    title: "Forward modelling of 2D Geological  Cross-section to 2D Synthetic Seismic  Section (Geo-Seismic Generator)",
    members: "Jalla Nagaraju, Santosh Kumar Sahu, Chandrakanh  Reddy Sunkesula, Sayantika Ghosh"
  },
  {
    id: "U2UCI367",
    title: "Continuous Fault Diagnosis Of SRP  Wells Using Motor Power Data",
    members: "Chaitanya Bhatt, Jayanth Boddu, Randheer S Meena,  Rajkumar Thakur, Ritesh Parashar"
  }
];

const supports = [
  {
    num: "01",
    title: "Structured development sessions",
    desc: "Teams are receiving regular sessions with technical  mentors and subject matter experts to guide their  build toward Demo Day standards."
  },
  {
    num: "03",
    title: "Business case sharpening",
    desc: "Every team is refining their management-ready  business case quantifying ROI,  defining implementation roadmaps, and  making the value case airtight for Demo Day."
  },
  {
    num: "02",
    title: "SAS platform integration",
    desc: "Teams are being actively supported to align their  technical architecture with SAS from the ground up  ensuring solutions are enterprise-ready."
  },
  {
    num: "04",
    title: "Data access resolution",
    desc: "One of the most common bottlenecks in AI  implementation is data access which is being resolved  proactively, before it becomes a blocker in the final  build phase."
  }
];

export default function ShortlistedTeams() {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCases, setFilteredCases] = useState(useCases);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = useCases.filter(
      (c) =>
        c.id.toLowerCase().includes(term) ||
        c.title.toLowerCase().includes(term) ||
        c.members.toLowerCase().includes(term)
    );
    setFilteredCases(filtered);
  }, [searchTerm]);

  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = "shortlisted";

  const handleTabClick = (tab) => {
    if (tab === "article") {
      navigate("/article");
    } else if (tab === "shortlisted") {
      navigate("/shortlisted");
    } else if (tab === "finalists") {
      navigate("/finalists");
    } else {
      navigate("/submission-insights");
    }
  };

  return (
    <div style={{
      fontFamily: "system-ui, -apple-system, sans-serif",
      background: "#000000",
      color: "#e8f5e9",
      minHeight: "100vh",
      overflowX: "hidden",
    }}>
      <style>{`
        * { box-sizing: border-box; }
        body { background-color: #000000; margin: 0; }
        ::selection { background: #00e5a033; }
        .fade-in { opacity: 0; transform: translateY(28px); transition: opacity 0.8s ease, transform 0.8s ease; }
        .fade-in.visible { opacity: 1; transform: none; }
        .support-card:hover { transform: translateY(-4px); border-color: #4ade8055 !important; }
        .quote-block {
          position: relative;
          margin: 40px 0;
          padding: 24px 32px;
          border-radius: 12px;
          background: linear-gradient(90deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 5, 5, 0.4) 100%);
       
        }
        .support-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-top: 28px;
        }
        .custom-input {
          width: 100%;
          padding: 12px 18px;
          background: #0a0a0a;
          border: 1px solid #222;
          border-radius: 8px;
          color: #fff;
          font-size: 0.95rem;
          outline: none;
          transition: all 0.25s ease;
        }
        .custom-input:focus {
          border-color: #10b981;
          box-shadow: 0 0 10px rgba(16, 185, 129, 0.15);
        }
        .cases-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
          font-size: 0.92rem;
        }
        .cases-table th {
          background: #0d1e0d;
          color: #4ade80;
          padding: 14px 16px;
          font-weight: 700;
          border-bottom: 2px solid #1a3a1a;
        }
        .cases-table td {
          padding: 14px 16px;
          border-bottom: 1px solid #161616;
          color: #d1d5db;
          vertical-align: top;
          line-height: 1.5;
        }
        .cases-table tr:hover td {
          background: #080808;
          color: #fff;
        }
        .mobile-cards {
          display: none;
        }
        @media (max-width: 768px) {
          .support-grid {
            grid-template-columns: 1fr;
          }
          .desktop-table-wrapper {
            display: none;
          }
          .mobile-cards {
            display: block;
          }
          .mobile-card {
            background: #080808;
            border: 1px solid #161616;
            border-radius: 10px;
            padding: 16px;
            margin-bottom: 14px;
          }
        }
      `}</style>

      {/* HERO */}
      <header
        style={{
          padding: "20px 16px 24px",
          marginTop: "80px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
          background: "#000000",
          borderBottom: "1px solid #1a1a1a",
        }}
      >
        {/* Tabs */}
        <div className="flex justify-center mb-6 w-full">
          <div className="flex flex-col sm:flex-row gap-2 bg-white/5 p-2 sm:p-1 rounded-2xl sm:rounded-full border border-white/10 w-[92%] sm:w-fit">
            <button
              onClick={() => handleTabClick("submission-insights")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "submission-insights"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Submission Insights
            </button>

            <button
              onClick={() => handleTabClick("article")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "article"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Evaluation Insights And Result
            </button>

            <button
              onClick={() => handleTabClick("shortlisted")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "shortlisted"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Shortlisted Use Cases
            </button>

            <button
              onClick={() => handleTabClick("finalists")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "finalists"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Meet the Finalists
            </button>
          </div>
        </div>

        {/* Heading */}
        <h1
          className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 sm:mb-6 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight leading-tight"
          style={{ maxWidth: "900px" }}
        >
          Udbhav 2.0: Journey of 35 Use Cases from Idea to Impact
          <span className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 sm:mb-6 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight leading-tight">

          </span>
        </h1>

        {/* Subtitle */}
        <p
          style={{
            fontSize: "clamp(0.95rem, 2.2vw, 1.1rem)",
            color: "#e1f0f1ff",
            maxWidth: "800px",
            lineHeight: 1.6,
            margin: "0 0 10px",
            padding: "0 16px",
            fontWeight: "500"
          }}
        >
          How rigorous evaluation, one-on-one conversations, and a new POC-first discipline produced ONGC's promising AI  portfolio
        </p>
      </header>

      {/* MAIN CONTENT AREA */}
      <main
        className={`fade-in ${visible ? "visible" : ""}`}
        style={{
          maxWidth: "1050px",
          margin: "0 auto",
          padding: "32px 16px 80px",
          background: "#000000",
        }}
      >
        {/* INTRO PARAGRAPHS */}
        <section style={{ marginBottom: "40px" }}>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
            When the submission window for Udbhav 2.0 closed, the real work began. Hundreds of ideas were on the  table, each one representing an ONGCian who had looked at the challenges in front of them and asked: can AI  help? The task was to identify which of these ideas were ready to be built, and to do so in a way that was  rigorous, fair, and genuinely respectful of every submission.
          </p>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db" }}>
            What followed was an intensive internal evaluation processes with rigorous one-on-one discussions, leadership  deliberation, and focussed management attention that signals just how seriously ONGC is treating this  program.
          </p>
        </section>

        {/* SECTION 1: A CONVERSATION WITH EVERY TEAM */}
        <section style={{ marginBottom: "48px", borderTop: "1px solid #111", paddingTop: "32px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(to right, #4ade80, #ef4444)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "16px", textAlign: "center" }}>
            The Beginning: A Conversation with Every Team
          </h2>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px" }}>
            The evaluation did not begin with a scoring matrix. It began with a conversation. The Udbhav team scheduled  and conducted individual one-on-one discussions with teams across the organization that were not a formality,  but a substantive engagement. Teams explained their ideas in their own words. The evaluation team asked  probing questions. Together, they explored the depth, feasibility, and business relevance of each proposal.
          </p>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af" }}>
            This process was time-consuming by design. The belief behind it was simple: an idea that cannot survive a  focused conversation is not ready to be built. And an idea that comes alive in discussion, revealing layers of  thinking that a written form cannot capture, deserves every chance to be recognized.
          </p>

          <div className="quote-block" style={{ background: "linear-gradient(299deg, rgb(232 32 32 / 6%) 0%, rgb(232 60 60 / 50%) 100%)", borderRadius: "12px", padding: "20px", marginBottom: "14px" }}>
            <p style={{ fontSize: "1.1rem", fontStyle: "italic", color: "#e8f5e9", margin: "0 0 8px", lineHeight: 1.6 }}>
              “We did not want to evaluate ideas. We wanted to understand them and that required a  conversation.”
            </p>
            <p style={{ fontSize: "0.9rem", color: "#a5d6a7", fontWeight: "600", margin: 0 }}>
              — Niyazi Farooque Ahmad, Team Udbhav
            </p>
          </div>

          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af" }}>
            What the discussions revealed was striking. Almost every idea was unique in some meaningful way. Even  submissions that addressed similar problems came with distinct approaches, different data contexts, and  varied implementation perspectives shaped by each team's own operational experience. The volume of  genuinely original thinking across ONGC was, in the honest assessment of the evaluation team, remarkable.
          </p>
        </section>

        {/* SECTION 2: LEADERSHIP DELIBERATION */}
        <section style={{ marginBottom: "48px", borderTop: "1px solid #111", paddingTop: "32px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(to right, #4ade80, #ef4444)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "16px", textAlign: "center" }}>
            The Shortlist: Leadership Deliberation
          </h2>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px" }}>
            After the discussion phase, the Udbhav team compiled inputs from every session and presented them,  alongside the original submissions, to a multi-disciplinary leadership team. This was very rigorous exercise  where the leadership invested significant time in reviewing, discussing, and debating the ideas.
          </p>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px" }}>
            Ideas were evaluated across four dimensions: the clarity and specificity of the problem being solved; the  soundness of the proposed AI approach; the feasibility of implementation within project timelines; and the  potential business value, whether through cost savings, revenue enhancement, safety improvement, or  operational efficiency. Ideas that were strong across all dimensions moved forward. Ideas with partial strength  were noted and will be taken up in subsequent rounds.
          </p>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af" }}>
            At the conclusion of this process, 52 ideas were shortlisted for POC development. Each shortlisted team was  individually reached out to, briefed on what was expected of them, and given a clear roadmap for the journey  ahead.
          </p>
        </section>

        {/* SECTION 3: DEVELOPING THE POC */}
        <section style={{ marginBottom: "48px", borderTop: "1px solid #111", paddingTop: "32px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(to right, #4ade80, #ef4444)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "16px", textAlign: "center" }}>
            Developing the POC and presenting to the management
          </h2>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px" }}>
            Shortlisted teams were required to develop a working POC: a functional demonstration of their AI solution,  grounded in real ONGC data and real operational context. This was Udbhav 2.0's most significant design change  from the previous edition. POC was not an aspiration, it was a requirement.
          </p>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px" }}>
            Teams built working prototypes, documented their business cases, and presented to a multi-disciplinary  leadership team. Each of teams received a 15-minute presentation window that were structured sessions  covering the problem statement, the AI solution, the POC outcomes, and the projected business value.  Leadership engaged actively asking questions, probing assumptions, and in many cases suggesting refinements  or connections between related ideas.
          </p>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af" }}>
            35 teams completed the POC stage and are now advancing to the final phase of Udbhav 2.0, developing their  full solution for the Final Presentation.
          </p>
        </section>

        {/* SECTION 4: TABLE OF 35 USE CASES */}
        <section style={{ marginBottom: "56px", borderTop: "1px solid #111", paddingTop: "32px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "24px", alignItems: "center" }}>
            <div>
              <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(to right, #4ade80, #ef4444)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", margin: "0 0 6px", textAlign: "center" }}>
                List of 35 Use Cases that completed their POC
              </h2>
              <p style={{ fontSize: "0.9rem", color: "#9ca3af", textAlign: "center" }}>
                Browse or search through the 35 pathbreaking projects currently in active POC phase.
              </p>
            </div>

            {/* Beautiful Search Input */}
            <div style={{ width: "100%", maxWidth: "450px" }}>
              <input
                type="text"
                placeholder="🔍 Search by ID, title, or team members..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="custom-input"
                style={{ textAlign: "center" }}
              />
              <p style={{ fontSize: "0.8rem", color: "#10b981", marginTop: "6px", fontWeight: "600", textAlign: "center" }}>
                Showing {filteredCases.length} of {useCases.length} shortlisted use cases
              </p>
            </div>
          </div>

          {/* DESKTOP TABLE */}
          <div className="desktop-table-wrapper" style={{
            background: "#050505",
            border: "1px solid #1a1a1a",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.5)"
          }}>
            {filteredCases.length > 0 ? (
              <table className="cases-table">
                <thead>
                  <tr>
                    <th style={{ width: "120px" }}>Use Case ID</th>
                    <th style={{ width: "350px" }}>Use Case Title</th>
                    <th>Team Members</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCases.map((c, i) => (
                    <tr key={i}>
                      <td style={{ fontWeight: "700", color: "#10b981" }}>{c.id}</td>
                      <td style={{ fontWeight: "600", color: "#fff" }}>{c.title}</td>
                      <td style={{ fontSize: "0.88rem", color: "#9ca3af" }}>{c.members}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{ padding: "40px", textAlign: "center", color: "#9ca3af" }}>
                No use cases match your search term.
              </div>
            )}
          </div>

          {/* MOBILE CARDS (RESPONSIVE VIEW) */}
          <div className="mobile-cards">
            {filteredCases.length > 0 ? (
              filteredCases.map((c, i) => (
                <div className="mobile-card" key={i}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                    <span style={{ fontWeight: "700", color: "#10b981", fontSize: "0.85rem" }}>{c.id}</span>
                  </div>
                  <h4 style={{ margin: "0 0 10px", fontSize: "1rem", color: "#fff", fontWeight: "700", lineHeight: "1.4" }}>
                    {c.title}
                  </h4>
                  <div style={{ fontSize: "0.82rem", color: "#9ca3af", lineHeight: "1.5" }}>
                    <strong style={{ color: "#d1d5db" }}>Team:</strong> {c.members}
                  </div>
                </div>
              ))
            ) : (
              <div style={{ padding: "30px", textAlign: "center", color: "#9ca3af" }}>
                No use cases match your search term.
              </div>
            )}
          </div>

          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginTop: "32px", marginBottom: "16px" }}>
            The quality of what was presented was, by any measure, extraordinary. Engineers, geoscientists, finance  professionals, HSE officers, and domain specialists from across ONGC stood before senior leadership and  demonstrated working AI solutions they had built themselves, often in parallel with their regular  responsibilities. The range of problems addressed, and the sophistication of the solutions presented, reflected  a workforce that is genuinely ready to lead ONGC's digital transformation from within.           </p>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af" }}>
            The solutions that emerged from these POCs do not exist in isolation but they complement and amplify the  transformation already underway across ONGC's functions. A particularly notable example is the Internal Audit  department, where multiple teams built AI-powered solutions that automate audit workflows, flag anomalies  proactively, and predict compliance risks before they surface. What was once a largely manual, retrospective  function is already transforming as a real-time intelligence system driven by ONGC's own talent.
          </p>
        </section>

        {/* SECTION 5: WHAT SHORTLISTED TEAMS ARE DOING NOW */}
        <section style={{ marginBottom: "56px", borderTop: "1px solid #111", paddingTop: "32px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(to right, #4ade80, #ef4444)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "12px", textAlign: "center" }}>
            What the Teams Are Doing Now
          </h2>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px" }}>
            Following the POC presentations, the teams have been selected to advance to the final stage of Udbhav 2.0.  These teams are now in the most intensive phase of the program: evolving their POC into a robust, scalable,  and fully demonstrable AI solution that can withstand the scrutiny of ONGC's top management at the Final  Presentation.
          </p>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#fff", fontWeight: "600" }}>
            This is not a polishing exercise. It is a build phase with four areas of focused support:
          </p>

          {/* 4 areas grid */}
          <div className="support-grid">
            {supports.map((s, i) => (
              <div
                className="support-card"
                key={i}
                style={{
                  background: "#080808",
                  border: "1px solid #181818",
                  borderRadius: "12px",
                  padding: "24px",
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: "1.8rem", fontWeight: "800", color: "#10b981", opacity: 0.85 }}>
                    {s.num}
                  </span>
                  <div style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "#10b981"
                  }} />
                </div>
                <h4 style={{ fontSize: "1.1rem", fontWeight: "700", color: "#fff", margin: 0 }}>
                  {s.title}
                </h4>
                <p style={{ fontSize: "0.9rem", color: "#9ca3af", lineHeight: "1.6", margin: 0 }}>
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* SECTION 6: DEMO DAY */}
        <section style={{ marginBottom: "48px", borderTop: "1px solid #111", paddingTop: "32px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(to right, #4ade80, #ef4444)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "16px", textAlign: "center" }}>
            The Final Presentation - Final Phase of Udbhav 2.0
          </h2>
          <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px" }}>
            The Final Presentation is a decision point. The solutions, presented to ONGC's top management will be  evaluated for enterprise-wide adoption, investment, and scale. Last year, the top teams from Udbhav 1.0  received ONGC's highest annual honour, the Chairman's Award. This year, the finalists will take that stage.
          </p>
          <div style={{
            border: "1px solid rgba(74, 222, 128, 0.4)",
            background: "linear-gradient(135deg, rgba(74, 222, 128, 0.05) 0%, rgba(248, 113, 113, 0.03) 100%)",
            borderRadius: "12px",
            padding: "20px 24px",
            marginBottom: "28px",
            boxShadow: "0 0 15px rgba(74, 222, 128, 0.03)"
          }}>
            <p style={{ fontSize: "1.02rem", lineHeight: 1.6, color: "#fff", margin: 0, fontWeight: "500", textAlign: "center" }}>
              542 ideas. 372 teams. Weeks of conversations, hours of leadership time, months of building. The finalists now stand at the threshold of completion, carrying with them not just their own ideas  but the collective ambition of every ONGCian who submitted one.
            </p>
          </div>

          <div style={{
            background: "#080808",
            border: "1px solid #1a3a1a",
            borderRadius: "12px",
            padding: "24px 32px",
            textAlign: "center",
            boxShadow: "0 4px 20px rgba(16, 185, 129, 0.05)",
            whiteSpace: "pre-wrap"
          }}>
            <p style={{ fontSize: "1.25rem", fontStyle: "italic", color: "#c01111ff", fontWeight: "600", margin: 0, lineHeight: 1.6 }}>
              “From an idea on a form to a solution in front of the Chairman. That is the Udbhav  journey  {"\n"}- and it is almost complete.”
            </p>
          </div>
        </section>

      </main>
    </div>
  );
}
